import App from "@/components/register";
import { wrapper } from "@/redux/store/store";
import { withCommonData } from "@/hocs/with-common-data";
import { withEhqPfe } from "@/hocs/with-ehq-pfe";
import { withParticipantData } from "@/hocs/with-participant-data";
import EHQLayout from "@/components/shared/layouts/ehq/default";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { fetchSignupFormQuestions } from "@/redux/features/signup-form-questions/thunk";
import { fetchMessageText } from "@/redux/features/message-text/thunk";
import type { ReactElement } from "react";
import { withUserSession } from "@/hocs/with-user-session";
import { SingleColumnLayout } from "@/storybook-components";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return (
    <EHQLayout>
      <SingleColumnLayout>{page}</SingleColumnLayout>
    </EHQLayout>
  );
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  withEhqPfe(
    withParticipantData(
      withUserSession(
        wrapper.getServerSideProps(
          (store) => async (ctx: GetServerSidePropsContext) => {
            const config = {
              headers: {
                cookie: ctx?.req?.headers?.cookie
              }
            };
            await store.dispatch(fetchSignupFormQuestions({ config }));
            await store.dispatch(fetchMessageText({ config }));
            const { disableSignup } = store.getState().settings.settings;
            if (disableSignup) {
              return {
                redirect: {
                  destination: "/login?signupdisabled=true",
                  permanent: false
                }
              };
            }
            return {
              props: {}
            };
          }
        )
      )
    )
  )
);
